import { memo } from "react";

import { type SelectedOption } from "@shopify/hydrogen-react/storefront-api-types";

import { CartItemSelectedOptionsView } from "./CartItemSelectedOptions.view";

type Props = {
  selectedOptions: Partial<SelectedOption>[] | undefined;
};

const CartItemSelectedOptionsBase = ({ selectedOptions }: Props) => {
  return <CartItemSelectedOptionsView selectedOptions={selectedOptions} />;
};

export const CartItemSelectedOptions = memo(CartItemSelectedOptionsBase);
